import React, { useState } from "react";
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import { useHistory } from "react-router-dom";
import { Button, Card, CardBody, CardHeader, Form, FormGroup, Label, Input, Row, Col, Alert } from "reactstrap";
import Loading from "../components/Loading";
import { createBrand } from "../utils/apiService";

const CreateOrganisationComponent = () => {
  const history = useHistory();
  const { getAccessTokenSilently } = useAuth0();

  const [form, setForm] = useState({
    orgName: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const token = await getAccessTokenSilently().catch(() => null);

      const payload = { name: form.orgName };

      await createBrand(payload, token);
      history.push("/brands");
    } catch (err) {
      setError(err?.message || "Failed to create brand");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <Card>
        <CardHeader>
          <h1 className="mb-0">Create Brand</h1>
        </CardHeader>
        <CardBody>
          {error && (
            <Alert color="danger">{error}</Alert>
          )}
          <Form onSubmit={onSubmit}>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="orgName">Brand Name</Label>
                  <Input id="orgName" name="orgName" value={form.orgName} onChange={onChange} required />
                </FormGroup>
              </Col>
            </Row>
            <Row>
            </Row>
            <div className="d-flex">
              <Button color="secondary" className="me-2" type="button" onClick={() => history.push('/brands')} disabled={submitting}>
                Cancel
              </Button>
              <Button color="primary" type="submit" disabled={submitting}>
                {submitting ? 'Creating...' : 'Create Brand'}
              </Button>
            </div>
          </Form>
        </CardBody>
      </Card>
    </div>
  );
};

export default withAuthenticationRequired(CreateOrganisationComponent, {
  onRedirecting: () => <Loading />,
});

